import React from 'react';
import clsx from 'clsx';
import Hint from './hint';

const IconButton = (props) => {
    const { title, icon, size = 30, className, onClick } = props;

    return (
        <Hint title={title}>
            <div
                className={clsx(
                    'inline-block rounded-full cursor-pointer text-gray-dark02 hover:bg-gray',
                    className
                )}
                onClick={onClick}
            >
                <div
                    className="flex justify-center items-center"
                    style={{ width: size, height: size }}
                >
                    {icon}
                </div>
            </div>
        </Hint>
    );
};

export default IconButton;
